// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunk~" + chunkId + "_" + "71341567934d52961649" + ".css";
};